import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzSpinComponent } from 'ng-zorro-antd/spin';
import { GlobalLoadingService } from '../../services/global-loading.service';

@Component({
  selector: 'app-global-loading',
  standalone: true,
  imports: [CommonModule, NzSpinComponent],
  templateUrl: './global-loading.component.html',
  styleUrls: ['./global-loading.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GlobalLoadingComponent {
  private loadingService = inject(GlobalLoadingService);
  readonly loading = this.loadingService.loading;
}
